import React from 'react';
import './App.css';
import Navibar from './Navbar/Navbar';
import Footer from './Footer/footer';


function App() {
  return (
    <>
    <div className='Containers'>
      <Navibar />
      <Footer/>
    </div>
    </>
  );
}

export default App;
